<template>
  <div>
    <b-button class="typo-butt-command" @click="apriModalRimuoviGruppo">
      <i class="fas fa-1x fa-object-ungroup mr-2" style="color:#009DE0"></i>
      {{$t("remove_group_button.text")}}
    </b-button>

    <!-- Modal rimuovi gruppo -->
    <b-modal
      :hide-footer="footer_hide"
      ok-only
      ref="modal"
      size="lg"
      :id="'modal-rimuovi-gruppo'+this._uid"
      :title="$t('remove_group_modal.title')"
      :ok-title="$t('remove_group_modal.button_salva')"
      @ok="handleOk"
    >
    <!-- Form di assegnazione gruppo -->
    <b-form-group class="ml-5 mt-2 mb-5">
            
            <!--select group from 1 to 16 -->
            <b-row>
              <b-col cols="12">
                <label class="h6 mt-2">{{$t("create_group_modal.select_group")}}</label>
              </b-col> 
              <b-col cols="12 mt-1">
              <b-form-checkbox-group
                v-model="selectedGroup"
                :options="groups"
                class="groupRemove"
                value-field="group"
                text-field="group"
                buttons
              ></b-form-checkbox-group>
              </b-col>    
            </b-row>
    </b-form-group>
  

    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "RimuoviGruppo",
  
  data() {
    return {
      
      selectedGroup: [],
      groups: Array.from({ length: 16 }, (v, i) => i+1),  
      
      footer_hide: false,
    };
  },
  props: {
    cu:null,
    lamp:null,
    sendAction: null,
    alerts:null
  },
  computed: {

        },
  methods: {
     apriModalRimuoviGruppo() {
      this.selectedGroup=[]; 
      if (this.cu.length>0 || this.lamp.length>0)
      {
          this.$bvModal.show('modal-rimuovi-gruppo'+this._uid);
      }
      else
      {
        var alert = {
                    timeLeft: 5,
                    state: "danger",
                    msg: this.$t('parametri_impianto_modal.error_select'),
                    countDownChanged: function(cd) {
                    }
                }
        this.alerts.push(alert);  
      }

     },
    handleOk(bvModalEvt) {
     // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.saveGroup();
    },
    saveGroup() {

      var params = {};
      params.command = "removeGroup";
      params.groupNumber = this.selectedGroup;
   
      console.log("parametri gruppo selezionato:", params);
      //Decommentare questo quando sarà implementato il comando reale
      this.sendAction(params);
      
      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs.modal.hide();
      });

    }
  }
};
</script>

<style lang="scss">
.groupRemove label { 
  background-color: whitesmoke;
  margin:5px; 
}
.groupRemove .btn.btn-secondary.active{ 
  background-color: orangered; 
}
</style>